import api from './api'
import axios from "axios";
import {
  CarrerasEstadisitcas,
  DataEstadisticasInterface,
  ProximasCarreras,
  ResponseProximasCarrerasIds
} from "../interfaces/priximas_carreras.interface"

export interface CarrerasAnterioresResponse {
  [key: string]: {
  ejemplar_id: number;
  ejemplar_nombre: string;
  proxima_carrera: {
    inscripcion: number;
    peso_ejemplar: number;
    jinete: {
      id: number;
      nombre: string;
    };
    preparador: {
      id: number;
      nombre: string;
    };
  };
  historial_carreras: Array<{
    car_id: number;
    car_fecha: string;
    car_id_hipodromo: number;
    car_distancia: number;
    car_resultado: number;
    car_tiempo_final: string;
    jinete: {
      id: number;
      nombre: string;
    };
    preparador: {
      id: number;
      nombre: string;
    };
  }>;
  }
}

// --- Interfaz para Handicap (existente) ---
export interface HandicapIndiceData {
    ejemplar_id: number;
    ejemplar_name: string;
    inscripcion_numero: number;
    jinete_name: string;
    preparador_name: string;
    peso_jinete_proximo: number;
    indice_promedio: number
    velocidad_promedio_ms: number
    peso_total_promedio_kg: number
    resultado_pts_promedio: number
    carreras_consideradas: number;
}

export interface HandicapRankingData {
    ejemplar_id: number;
    ejemplar_name: string;
    inscripcion_numero: number;
    ranking_score: number;
}

export interface HandicapResponse {
    pro_car_id_hipodromo: number;
    participantes_resumen: HandicapIndiceData[];
    ranking_general: HandicapRankingData[];
}

// --- Interfaces para la nueva respuesta combinada ---
export interface PrediccionCombinada {
  // El tipo de pro_car_predition podría ser string o number dependiendo de la serialización exacta
  pro_car_predition: string | number;
  pro_car_inscripcion: number;
  pro_car_eje_name: string;
}

// ParticipanteResumen ya está definida arriba como HandicapIndiceData
// RankingGeneral ya está definida arriba como HandicapRankingData

export interface PrediccionHandicapResponse {
  hipodromo_id: number;
  predicciones: PrediccionCombinada[]; // Será una lista vacía si no es premium, pero la llamada fallará con 403
  ranking_general: HandicapRankingData[];
  participantes_resumen: HandicapIndiceData[]; // Reutilizamos la interfaz
}


// --- Funciones de servicio actualizadas ---

const getEndpoint = (hipodromoId: number, hipoUrl: string, chsUrl: string) => {
    return hipodromoId === 2 ? chsUrl : hipoUrl;
};

export const getCarrerasAnteriores = async (proCarIdHipodromo: number, hipodromoId: number = 1): Promise<CarrerasAnterioresResponse> => {
  try {
    const url = getEndpoint(
        hipodromoId, 
        `/api/carreras-anteriores/?pro_car_id_hipodromo=${proCarIdHipodromo}`,
        `/api/chs/carreras-anteriores/?pro_car_id_hipodromo=${proCarIdHipodromo}`
    );
    const response = await api.get<CarrerasAnterioresResponse>(url);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      console.error('Error de autenticación - Redirigiendo a login');
      window.location.href = '/login';
    }
    throw error;
  }
};

export const getCarrerasEstad =  (eje_id: number, jin_id: number, pre_id:number, hipodromoId: number = 1):Promise<CarrerasEstadisitcas> =>{
    return new Promise<CarrerasEstadisitcas>((response, reject) => {
        const url = getEndpoint(
            hipodromoId,
            `/api/list_ejejinpre/${eje_id}/${jin_id}/${pre_id}/`,
            `/api/chs/list_ejejinpre/${eje_id}/${jin_id}/${pre_id}/` // Asumiendo simetría, verificar si falla
        );
        api.get<CarrerasEstadisitcas>(url).then((res)=> {
            response(res.data)
        }).catch((error)=>reject(error))
    })
}

export const getCarrerasIds = async (id: number, hipodromoId: number = 1):Promise<ProximasCarreras[]> =>{
   try {
    const url = getEndpoint(
        hipodromoId,
        `/api/proximas_carrera_list/${id}/`,
        `/api/chs/proximas_carrera_list/${id}/`
    );
    const response = await api.get<ProximasCarreras[]>(url);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      console.error('Error de autenticación - Redirigiendo a login');
      window.location.href = '/login';
    }
    throw error;
  }
}

export const getCarreras = async (hipodromoId: number = 1):Promise<ResponseProximasCarrerasIds[]> =>{
    try {
    const url = getEndpoint(
        hipodromoId,
        `/api/list_id_hipo`,
        `/api/chs/list_id_hipo`
    );
    const response = await api.get<ResponseProximasCarrerasIds[]>(url);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      console.error('Error de autenticación - Redirigiendo a login');
      // window.location.href = '/login';
    }
    throw error;
  }
}

export const getCarrerasEstadisticas = async (id: number, hipodromoId: number = 1):Promise<DataEstadisticasInterface> =>{
    try {
    // Nota: No se confirmó endpoint de CHS para esto en urls.py, se mantiene Hipo por defecto o se intenta espejo
    const url = getEndpoint(
        hipodromoId,
        `/api/proxima_carrera_estadista/${id}/`,
        `/api/proxima_carrera_estadista/${id}/` // Fallback a Hipo si no existe CHS específico
    );
    const response = await api.get<DataEstadisticasInterface>(url);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      console.error('Error de autenticación - Redirigiendo a login');
      window.location.href = '/login';
    }
    throw error;
  }
}

export const getEjemplarEstadisticas = async (eje: number, jin:number, pre:number, hipodromoId: number = 1):Promise<DataEstadisticasInterface> =>{
    try {
    const url = getEndpoint(
        hipodromoId,
        `/estad_ejemplar/${eje}/${jin}/${pre}/`,
        `/api/chs/estad_ejemplar/${eje}/${jin}/${pre}/`
    );
    const response = await api.get<DataEstadisticasInterface>(url);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      console.error('Error de autenticación - Redirigiendo a login');
      window.location.href = '/login';
    }
    throw error;
  }
}

export interface TopData {
  ejemplares: { nombre: string; victorias: number }[];
  jinetes: { nombre: string; victorias: number }[];
  preparadores: { nombre: string; victorias: number }[];
}

export const getTops = async (hipodromoId: number = 1): Promise<TopData> => {
  try {
    const url = getEndpoint(
        hipodromoId,
        '/api/tops/',
        '/api/chs/tops/'
    );
    const response = await api.get<{
      status: string;
      data: TopData;
      message: string;
    }>(url);
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      console.error('Error de autenticación - Redirigiendo a login');
      window.location.href = '/login';
    }
    throw error;
  }
};

export interface Prediccion {
  pro_car_predition: string;
  pro_car_inscripcion: number;
  pro_car_eje_name: string;
}

export const getPredicciones = async (raceId: number, hipodromoId: number = 1): Promise<Prediccion[]> => {
  try {
    const url = getEndpoint(
        hipodromoId,
        `/api/prediccion-hipodromo/${raceId}/`,
        `/api/chs/prediccion-hipodromo/${raceId}/`
    );
    const response = await api.get<Prediccion[]>(url);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response?.status === 401) {
        console.error('Error de autenticación - Redirigiendo a login');
        window.location.href = '/login';
      } else if (error.response?.status === 403) {
        throw new Error('Se requiere suscripción Premium para acceder a las predicciones');
      }
    }
    throw error;
  }
};


export const getHandicapData = async (proCarIdHipodromo: number, hipodromoId: number = 1): Promise<HandicapResponse> => {
  try {
    const url = getEndpoint(
        hipodromoId,
        `/api/handicap/carrera/${proCarIdHipodromo}/`,
        `/api/chs/handicap/carrera/${proCarIdHipodromo}/`
    );
    const response = await api.get<HandicapResponse>(url);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
       if (error.response?.status === 401) {
         console.error('Error de autenticación - Redirigiendo a login');
         window.location.href = '/login';
      } else {
         console.error('Error al obtener datos de Handicap:', error.message);
      }
    } else {
       console.error('Error inesperado:', error);
    }
    throw error;
  }
};

// --- NUEVA FUNCIÓN DE SERVICIO PARA PREDICCIÓN Y HANDICAP COMBINADO ---
export const getPrediccionHandicapCombinado = async (raceId: number, hipodromoId: number = 1): Promise<PrediccionHandicapResponse> => {
  try {
    const url = getEndpoint(
        hipodromoId,
        `/api/prediccion-handicap/${raceId}/`,
        `/api/chs/prediccion-handicap/${raceId}/`
    );
    const response = await api.get<PrediccionHandicapResponse>(url);
    return response.data;
  } catch (error) {
    // Manejo de errores específico para este endpoint
    if (axios.isAxiosError(error)) {
      if (error.response?.status === 401) {
        console.error('Error de autenticación (401) - Redirigiendo a login');
        window.location.href = '/login'; // O manejo de redirección apropiado
        // Lanzamos un error para detener la ejecución en el componente
        throw new Error('Autenticación requerida.');
      } else if (error.response?.status === 403) {
         console.error('Error de autorización (403): Suscripción Premium requerida.');
         // Lanzamos un error específico que el componente puede capturar
         throw new Error('Se requiere suscripción Premium para acceder a esta función.');
      } else if (error.response?.status === 404) {
          console.error('Error (404): No se encontraron datos para el hipódromo especificado.');
          throw new Error(`No se encontraron datos para el hipódromo.`);
      } else {
         console.error(`Error ${error.response?.status} al obtener datos combinados:`, error.message);
         throw new Error('Ocurrió un error al cargar los datos.'); // Error genérico
      }
    } else {
       console.error('Error inesperado al obtener datos combinados:', error);
       throw new Error('Ocurrió un error inesperado.'); // Error genérico
    }
  }
};

export interface AgentPredictionResponse {
  hipodromo_id: number;
  user_prompt: string;
  proximas_carreras_data: any[]; // Puedes definir una interfaz más específica si es necesario
  analisis_ejemplares: any[]; // Puedes definir una interfaz más específica si es necesario
  analysis_summary: string;
}

export const getAgentPrediction = async (raceId: number, prompt?: string, hipodromoId: number = 1): Promise<AgentPredictionResponse> => {
  try {
    const url = getEndpoint(
        hipodromoId,
        '/api/analyze-race/',
        '/api/chs/analyze-race/'
    );
    // Nota: El backend de Analyze Race suele esperar "hipodromo_id" en el body para identificar la carrera o el hipodromo?
    // Revisando AgentView, pasa el ID de la carrera como primer argumento a getAgentPrediction.
    // El backend RaceAnalyzerAgentView espera 'hipodromo_id' en el body, pero parece referirse al ID de la carrera (pk).
    // Mantendremos la lógica actual pasando `raceId` como `hipodromo_id` en el body, 
    // pero cambiando la URL si es CHS.
    
    const data = { hipodromo_id: raceId, prompt: prompt || '' }; 
    const response = await api.post<AgentPredictionResponse>(url, data, {timeout: 370000}); 
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response?.status === 401) {
        console.error('Error de autenticación (401) - Redirigiendo a login');
        window.location.href = '/login';
        throw new Error('Autenticación requerida.');
      } else if (error.response?.status === 403) {
        console.error('Error de autorización (403): Suscripción Premium requerida.');
        throw new Error('Se requiere suscripción Premium para acceder a esta función.');
      } else if (error.response?.status === 404) {
        console.error('Error (404): No se encontraron datos.');
        throw new Error(`No se encontraron datos para la carrera ${raceId}.`);
      } else {
        console.error(`Error ${error.response?.status} al obtener predicción del agente:`, error.message);
        throw new Error('Ocurrió un error al cargar la predicción.');
      }
    } else {
      console.error('Error inesperado al obtener predicción del agente:', error);
      throw new Error('Ocurrió un error inesperado.');
    }
  }
};
